@import "../../global/gx-ide-common.scss";
@import "../../global/gx-ide-mixins.scss";
@import "../../global/temporary-mercury-overrides/_button.scss";
@import "../../../node_modules/@genexus/mercury/dist/assets/scss/helpers.scss";

:host {
  display: grid;
  inline-size: 100%;
  block-size: 100%;
}

.file-uploader-dialog {
  display: grid;
  grid-template-rows: 1fr max-content;
  block-size: 100%;
  min-block-size: 0;
  position: relative;

  .dialog-content {
    min-block-size: 0;
    overflow: auto;
  }
}

.file-uploader {
  display: flex;
  flex-direction: column;
  inline-size: 100%;
  block-size: 100%;

  &__list {
    display: flex;
    flex-direction: column;
    inline-size: 100%;
    block-size: 100%;

    &-header {
      position: sticky;
      top: 0;
      z-index: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &-content {
      flex: 1;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      gap: var(--spacing-gap-l);
      @include list-reset;
      padding-block-end: var(--spacing-padding-l);
    }
  }

  &__list-title-container {
    display: flex;
    align-items: center;
    gap: var(--spacing-gap-xs);
    white-space: nowrap;
  }

  &__drop-zone {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    inline-size: 100%;
    block-size: 100%;
    border: 2px dashed var(--color-border-neutral-default);
    border-radius: 8px;
    transition:
      border-color 0.3s ease,
      background-color 0.3s ease,
      opacity 0.3s ease;

    &--dragging {
      border-color: var(--color-accent-primary-default);
      background: var(--color-accent-primary-hover);
      opacity: 0.7;
    }

    .text-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--spacing-gap-xs);
      margin-block-start: 8px;
    }
  }
}

.label-primary-row {
  display: flex;
  align-items: center;
  gap: var(--spacing-gap-m);
}
